import { post } from './client';
import { API_ENDPOINTS } from '../config/api';

export interface VoteVendor {
  id: number;
  name: string;
}

export interface VoteResult {
  name: string;
  vote_count: number;
}

interface VoteStatusResponse {
  has_voted: boolean;
  voted_vendor_id: number | null;
  vendors: VoteVendor[];
  results: VoteResult[];
  error?: {
    message: string;
  };
}

interface SubmitVoteResponse {
  success: boolean;
  results: VoteResult[];
  error?: {
    message: string;
  };
}

export async function getVoteStatus(loginKey: string, eventId: number) {
  return post<VoteStatusResponse>(API_ENDPOINTS.VOTE_STATUS, {
    login_key: loginKey,
    event: eventId,
  });
}

export async function submitVote(
  loginKey: string,
  eventId: number,
  vendorId: number,
) {
  return post<SubmitVoteResponse>(API_ENDPOINTS.VOTE, {
    login_key: loginKey,
    event: eventId,
    vendor_id: vendorId,
  });
}

export default {
  getVoteStatus,
  submitVote,
};
